export const languages = [
  { key: 'afrikaans', text: 'Afrikaans', value: 'Afrikaans' },
  { key: 'albanian', text: 'Albanian', value: 'Albanian' },
  { key: 'amharic', text: 'Amharic', value: 'Amharic' },
  { key: 'any', text: 'Any', value: 'Any' },
  { key: 'arabic', text: 'Arabic', value: 'Arabic' },
  { key: 'armenian', text: 'Armenian', value: 'Armenian' },
  { key: 'asl', text: 'ASL', value: 'ASL' },
  { key: 'auslan', text: 'Auslan', value: 'Auslan' },
  { key: 'belarusian', text: 'Belarusian', value: 'Belarusian' },
  { key: 'bsl', text: 'BSL', value: 'BSL' },
  { key: 'bulgarian', text: 'Bulgarian', value: 'Bulgarian' },
  { key: 'cantonese', text: 'Cantonese', value: 'Cantonese' },
  { key: 'catalan', text: 'Catalan', value: 'Catalan' },
  { key: 'chinese', text: 'Chinese', value: 'Chinese' },
  {
    key: 'chinese-mandarin',
    text: 'Chinese (Mandarin)',
    value: 'Chinese (Mandarin)',
  },
  {
    key: 'chinese-wenzhounese',
    text: 'Chinese (Wenzhounese)',
    value: 'Chinese (Wenzhounese)',
  },
  { key: 'cornish', text: 'Cornish', value: 'Cornish' },
  { key: 'croatian', text: 'Croatian', value: 'Croatian' },
  { key: 'czech', text: 'Czech', value: 'Czech' },
  { key: 'danish', text: 'Danish', value: 'Danish' },
  { key: 'dutch', text: 'Dutch', value: 'Dutch' },
  { key: 'english', text: 'English', value: 'English' },
  { key: 'esperanto', text: 'Esperanto', value: 'Esperanto' },
  { key: 'estonian', text: 'Estonian', value: 'Estonian' },
  { key: 'filipino', text: 'Filipino', value: 'Filipino' },
  { key: 'finnish', text: 'Finnish', value: 'Finnish' },
  { key: 'french', text: 'French', value: 'French' },
  {
    key: 'gaelic-scottish',
    text: 'Gaelic (Scottish)',
    value: 'Gaelic (Scottish)',
  },
  { key: 'german', text: 'German', value: 'German' },
  { key: 'greek', text: 'Greek', value: 'Greek' },
  { key: 'hakka', text: 'Hakka', value: 'Hakka' },
  { key: 'hausa', text: 'Hausa', value: 'Hausa' },
  { key: 'hebrew', text: 'Hebrew', value: 'Hebrew' },
  { key: 'hindi', text: 'Hindi', value: 'Hindi' },
  { key: 'hungarian', text: 'Hungarian', value: 'Hungarian' },
  { key: 'icelandic', text: 'Icelandic', value: 'Icelandic' },
  { key: 'igbo', text: 'Igbo', value: 'Igbo' },
  { key: 'indonesian', text: 'Indonesian', value: 'Indonesian' },
  { key: 'irish', text: 'Irish', value: 'Irish' },
  { key: 'italian', text: 'Italian', value: 'Italian' },
  { key: 'japanese', text: 'Japanese', value: 'Japanese' },
  { key: 'korean', text: 'Korean', value: 'Korean' },
  { key: 'kurdish', text: 'Kurdish', value: 'Kurdish' },
  { key: 'latvian', text: 'Latvian', value: 'Latvian' },
  { key: 'lithuanian', text: 'Lithuanian', value: 'Lithuanian' },
  { key: 'maori', text: 'Maori', value: 'Maori' },
  { key: 'mongolian', text: 'Mongolian', value: 'Mongolian' },
  { key: 'ndebele', text: 'Ndebele', value: 'Ndebele' },
  { key: 'norwegian', text: 'Norwegian', value: 'Norwegian' },
  { key: 'occitan', text: 'Occitan', value: 'Occitan' },
  { key: 'oromo', text: 'Oromo', value: 'Oromo' },
  { key: 'persian', text: 'Persian', value: 'Persian' },
  { key: 'polish', text: 'Polish', value: 'Polish' },
  { key: 'portugese', text: 'Portugese', value: 'Portugese' },
  { key: 'romanian', text: 'Romanian', value: 'Romanian' },
  { key: 'russian', text: 'Russian', value: 'Russian' },
  { key: 'sepedi', text: 'Sepedi', value: 'Sepedi' },
  { key: 'serbian', text: 'Serbian', value: 'Serbian' },
  { key: 'shona', text: 'Shona', value: 'Shona' },
  { key: 'slovak', text: 'Slovak', value: 'Slovak' },
  { key: 'spanish', text: 'Spanish', value: 'Spanish' },
  { key: 'swahili', text: 'Swahili', value: 'Swahili' },
  { key: 'swati', text: 'Swati', value: 'Swati' },
  { key: 'swedish', text: 'Swedish', value: 'Swedish' },
  { key: 'tagalog', text: 'Tagalog', value: 'Tagalog' },
  { key: 'taiwanese', text: 'Taiwanese', value: 'Taiwanese' },
  { key: 'thai', text: 'Thai', value: 'Thai' },
  { key: 'tsonga', text: 'Tsonga', value: 'Tsonga' },
  { key: 'tswana', text: 'Tswana', value: 'Tswana' },
  { key: 'turkish', text: 'Turkish', value: 'Turkish' },
  { key: 'ukrainian', text: 'Ukrainian', value: 'Ukrainian' },
  { key: 'urdu', text: 'Urdu', value: 'Urdu' },
  { key: 'venda', text: 'Venda', value: 'Venda' },
  { key: 'vietnamese', text: 'Vietnamese', value: 'Vietnamese' },
  { key: 'welsh', text: 'Welsh', value: 'Welsh' },
  { key: 'wolof', text: 'Wolof', value: 'Wolof' },
  { key: 'xhosa', text: 'Xhosa', value: 'Xhosa' },
  { key: 'yiddish', text: 'Yiddish', value: 'Yiddish' },
  { key: 'zulu', text: 'Zulu', value: 'Zulu' },
];
